import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, timer } from 'rxjs';
import { finalize, scan, take, takeUntil, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EmailOtpModel, GoogleOtpModel, TwoFactorResponseModel } from '../model/two-factor.model';

@Injectable({
  providedIn: 'root'
})

export class MfaService {

  private static readonly MFA_URL = environment.apiV1 + '/mfa/';
  private static readonly GOOGLE_SETUP = environment.apiV1 + '/mfa/google';
  private static readonly EMAIL_SETUP = environment.apiV1 + '/mfa/email';
  private static readonly VERIFY_CODE = environment.apiV1 + '/verify?code=';
  private static readonly ALL_USERS_MANDATORY = environment.apiV1 + '/mfa/user/authenticator/list';
  private static readonly RESET_MFA = environment.apiV1 + '/mfa/reset';
  private static readonly ALL_FIRM_USER_ENABLE_DISABLE = environment.apiV1 + '/mfa/firm/users?status=';
  private static readonly GOOGLE_OTP = environment.apiV1 + '/mfa/google/verify?code=';
  private static readonly EMAIL_OTP = environment.apiV1 + '/mfa/email/verify?code=';
  private static readonly DISABLE_MFA: string = environment.apiV1 + '/mfa/status?status=';
  private readonly COUNTDOWN_TIMER: number = 60;
  private resendTimer$: Subject<any> = new Subject<any>();


  constructor(private http: HttpClient) {
  }

  public fetchGoogleAuthenticationStatus(): Observable<any> {
    return this.http.get<any>(MfaService.GOOGLE_SETUP);
  }

  public fetchGoogleAuthenticationDetails(): Observable<TwoFactorResponseModel> {
    return this.http.post<TwoFactorResponseModel>(MfaService.GOOGLE_SETUP, {});
  }

  public fetchEmailAuthentication(): Observable<EmailOtpModel> {
    return this.http.post<EmailOtpModel>(MfaService.EMAIL_SETUP, {});
  }

  public resendCodeTimer(): Observable<number> {
    return timer(0, 1000).pipe(
      tap(resp => console.log('TAPPED-RESPONSE', resp)),
      take(this.COUNTDOWN_TIMER + 1),
      scan((remainingTime) => remainingTime - 1, this.COUNTDOWN_TIMER),
      finalize(() => {
        console.log('Countdown-Service-Completed');
      }),
      takeUntil(this.resendTimer$)
    );
  }

  public resetTimer(): void {
    this.resendTimer$.next('');
  }

  public getAuthDisplayName(name: string): 'Google Authenticator' | 'Email ID' | 'None' {
    return name === 'GOOGLE_AUTHENTICATOR' ? 'Google Authenticator' : (name === 'EMAIL' ? 'Email ID' : 'None');
  }

  public fetchOTPStatus(code: number, type: 'google' | 'email'): Observable<any> {
    const path = MfaService.MFA_URL + type + MfaService.VERIFY_CODE + code;
    return this.http.get<any>(path);
  }

  public fetchGoogleOtpStatus(code: number): Observable<boolean> {
    const path = MfaService.GOOGLE_OTP + code;
    return this.http.get<boolean>(path);
  }

  public fetchEmailOtpStatus(code: number): Observable<GoogleOtpModel> {
    const path = MfaService.EMAIL_OTP + code;
    return this.http.get<GoogleOtpModel>(path);
  }

  public FetchAuthList(): Observable<any> {
    return this.http.get<any>(MfaService.ALL_USERS_MANDATORY, {});
  }

  public resetMFAbySuperAdmin(userId: any): Observable<any> {
    const path = MfaService.RESET_MFA;
    return this.http.delete(path, userId);
  }

  public EnableDisableMFAbySuperAdmin(status: boolean): Observable<any> {
    const path = MfaService.ALL_FIRM_USER_ENABLE_DISABLE + status;
    return this.http.put(path, {});
  }

  public disableMFA(status: boolean): Observable<GoogleOtpModel> {
    const path: string = MfaService.DISABLE_MFA + status;
    return this.http.put<GoogleOtpModel>(path, {});
  }
}
